import { Component, ContentChild, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { ReceiptBreakdownDirective } from './receipt-breakdown.directive';
import { ReceiptConclusionDirective } from './receipt-conclusion.directive';
import { StickyWrapperComponent } from '../sticky-wrapper/sticky-wrapper.component';

@Component({
  selector: 'wl-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.ed.scss', './receipt.component.essent.scss'],
  standalone: true,
  imports: [StickyWrapperComponent, NgTemplateOutlet],
})
export class ReceiptComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sticky = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stickyWrapperClass = '';

  @ContentChild(ReceiptBreakdownDirective)
  breakdown?: ReceiptBreakdownDirective;

  @ContentChild(ReceiptConclusionDirective)
  conclusion?: ReceiptConclusionDirective;
}
